module.exports = __webpack_public_path__ + "static/media/successRadious.0fd7ebf2.svg";